export default "__VITE_ASSET__ChRM_pzP__"